// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseHref:'/dclic',
  env: 'val',
  apiUrl: 'https://cllaj-api.bambootech.fr/api',
  phpApiUrl: 'https://val.cllaj-martinique.fr/api',
  defaultApiSource: 'php',
  enableApiComparison: true,
  uploadedFilesUrl: 'https://val.cllaj-martinique.fr/api/filebypath/',
  cllajUrl: 'https://val.cllaj-martinique.fr',
  adminOnly:false,
  googleMapsApiKey: 'AIzaSyBDTrEJM4jR3DXxRidbLwiNDPAKSrvoiW0'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
